import jQuery from "jquery";
global.jquery = jQuery;
global.$ = jQuery;
window.$ = window.jQuery = require("jquery");

import Swiper from "swiper"; // eslint-disable-line no-unused-vars

var maxWidth = 900;
var wW;
var wH;

$(function() {
  /*==================================================
		Scroll Event
	================================================== */
  $(window).scroll(function() {
    // フッター位置調整
    $(".footerStyle").css("min-height", $("footer").outerHeight(true));

    // When crossing the slideshow area
    if ($(window).scrollTop() > 200 - $("header").height()) {
      if (!$("header").hasClass("bgactive")) $("header").addClass("bgactive");
      if (!$("#totop").hasClass("active")) $("#totop").addClass("active");
      if (!$("#btnpopup").hasClass("active")) $("#btnpopup").addClass("active");
      if (!$("#modelfootbtns").hasClass("active"))
        $("#modelfootbtns").addClass("active");
      if (!$("#financingplanbtns").hasClass("active"))
        $("#financingplanbtns").addClass("active");
      if (!$("#footertotalcost").hasClass("active"))
        $("#footertotalcost").addClass("active");
    } else {
      if ($("header").hasClass("bgactive")) $("header").removeClass("bgactive");
      if ($("#totop").hasClass("active")) $("#totop").removeClass("active");
      if ($("#btnpopup").hasClass("active"))
        $("#btnpopup").removeClass("active");
      if ($("#modelfootbtns").hasClass("active"))
        $("#modelfootbtns").removeClass("active");
      if ($("#financingplanbtns").hasClass("active"))
        $("#financingplanbtns").removeClass("active");
      if ($("#footertotalcost").hasClass("active"))
        $("#footertotalcost").removeClass("active");
    }
    if ($(window).scrollTop() + $(window).height() > $("footer").offset().top) {
      $("#btnpopup").css({
        position: "absolute",
        top: -($("#btnpopup").height() + $("#totop").height() + 20) + "px",
        bottom: "inherit"
      });
      $("#totop").css({
        position: "absolute",
        top: -($("#totop").height() + 10) + "px",
        bottom: "inherit"
      });
      $("#modelfootbtns").removeAttr("style");
      $("#financingplanbtns").removeAttr("style");
      $("#financingplanbtns .wrap").removeAttr("style");
    } else {
      $("#btnpopup").removeAttr("style");
      $("#totop").removeAttr("style");
      $("#modelfootbtns").css({ position: "fixed" });
      $("#financingplanbtns").css({ position: "fixed" });
      if ($(window).width() <= maxWidth)
        $("#financingplanbtns .wrap").css({ width: "95%" });
    }

    if ($("main#option").length || $("main#plandetail").length) {
      //option total cost
      if (
        $(window).scrollTop() + $(window).height() >
        $("footer").offset().top - 20
      ) {
        $("#footertotalcost").css({ position: "static" });
        $("#footertotalcost .wrap").css({ width: "100%" });
        $("section#option").removeAttr("style");
      } else {
        $("#footertotalcost").removeAttr("style");
        $("#footertotalcost .wrap").removeAttr("style");
        $("section#option").css({
          "padding-bottom": $("#footertotalcost").outerHeight() + "px"
        });
      }
    }

    if ($("main#financingplan").length && !$("main#plandetail").length) {
      //financingPlan button area
      if (
        $(window).scrollTop() + $(window).height() >
        $("footer").offset().top - 20
      ) {
        $("#fpBtns").css({ position: "static" });
        $("#fpBtns .wrap").css({ width: "100%" });
        $("section#fp").removeAttr("style");
      } else {
        $("#fpBtns").removeAttr("style");
        $("#fpBtns .wrap").removeAttr("style");
        $("section#fp").css({
          "padding-bottom": $("#fpBtns").outerHeight() + "px"
        });
      }
      if (
        $(window).scrollTop() + $("header").height() >
        $("section#fp").offset().top - $(window).height() * 0.5
      ) {
        if (!$("#fpBtns").hasClass("active")) $("#fpBtns").addClass("active");
      } else {
        if ($("#fpBtns").hasClass("active")) $("#fpBtns").removeClass("active");
      }
    }
  });

  /*==================================================
		Scroll To Anker
	================================================== */
  var urlHash = location.hash;
  if (urlHash) {
    $("body,html")
      .stop()
      .scrollTop(0);
    setTimeout(function() {
      scrollToAnker(urlHash);
    }, 400);
  }
  $('a[href^="#"]').click(function() {
    var href = $(this).attr("href");
    if (href.match(/popup/)) return;
    var hash = href == "#" || href == "" ? "html" : href;
    scrollToAnker(hash);
    return false;
  });
  function scrollToAnker(hash) {
    var target = $(hash);
    var position;
    var headerheight = $("header").height() + 0;
    position =
      target.offset().top == 0
        ? target.offset().top
        : target.offset().top - headerheight;

    $("body,html")
      .stop()
      .animate(
        { scrollTop: position },
        { duration: 500, easing: "easeOutCubic", complete: function() {} }
      );
  }

  $("body").on("click", ".popupclose", function() {
    $(".popup-modal").magnificPopup("close");
  });

  /*==================================================
    accordion menu
  ================================================== */
  $("body").on("click", ".accordion_one .accordion_header", function() {
    if ($("main#equipment").length || $("main#documentDownload").length) {
      if ($(this).hasClass("child") && $(window).width() > maxWidth) return;
      if (!$(this).hasClass("child")) {
        $(".accordion_one > .accordion_header")
          .not(this)
          .removeClass("open");
        $(".accordion_one > .accordion_header")
          .not(this)
          .next()
          .slideUp(300);
      }
      $(this)
        .next(".accordion_inner")
        .slideToggle();
      $(this).toggleClass("open");
      setTimeout(
        $.proxy(function() {
          if (!$(this).hasClass("noanker")) scrollToAnker($(this).parent());
        }, this),
        300
      );
    }
    if ($("main#contract").length || $("main#financingplan").length) {
      if (
        $("main#financingplan.conf").length ||
        $("main#contract .conf1").length
      )
        return;
      $(".accordion_one .accordion_header")
        .not(this)
        .removeClass("open");
      $(".accordion_one .accordion_header")
        .not(this)
        .next()
        .slideUp(300);
      $(this)
        .next(".accordion_inner")
        .slideToggle(300);
      $(this).toggleClass("open");
      setTimeout(
        $.proxy(function() {
          if (!$(this).hasClass("noanker")) scrollToAnker($(this).parent());
        }, this),
        300
      );
    }
  });
  if (
    $("main#contract").length ||
    $("main#financingplan").length ||
    $("main#equipment").length ||
    $("main#documentDownload").length
  ) {
    if (
      $("main#contract.conf").length ||
      $("main#financingplan.conf").length ||
      $("main#contract .conf1").length
    ) {
      $(".accordion_one .accordion_header")
        .next(".accordion_inner")
        .slideToggle(0);
      $(".accordion_one .accordion_header").toggleClass("open");
    } else {
      $(".accordion_one .accordion_header")
        .eq(0)
        .next(".accordion_inner")
        .slideToggle(0);
      $(".accordion_one .accordion_header")
        .eq(0)
        .toggleClass("open");
    }
  }

  $("#financingplanbtns .price > div").on("click", function() {
    if (wW <= maxWidth) {
      $(this)
        .next("ul")
        .slideToggle();
      $(this).toggleClass("open");
    }
  });
  if (wW <= maxWidth) {
    $("#financingplanbtns .price > ul").slideToggle();
    $("#financingplanbtns .price > div").toggleClass("open");
  }

  /*==================================================
    tab menu
  ================================================== */
  $(".tab a").click(function() {
    $(this)
      .parent()
      .addClass("active")
      .siblings(".active")
      .removeClass("active");
    var tabContents = $(this).attr("name");
    $(tabContents)
      .addClass("active")
      .siblings(".active")
      .removeClass("active");
    return false;
  });
});

$(window).on("load orientationchange resize", function() {
  wW = $(window).width();
  wH = $(window).height();
  var headerHeight = $("header").height(); // eslint-disable-line no-unused-vars
  if (wW > maxWidth) {
    //menu
    $(".overlay").removeAttr("style");
    $(".menu-trigger, nav").removeClass("active");
    //accordion
    if ($("main#equipment").length || $("main#documentDownload").length) {
      $(".accordion_inner .accordion_inner").removeAttr("style");
      $(".accordion_inner .accordion_header").removeClass("open");
    }
    $("#financingplan #financingplanbtns .price > div").removeClass("open");
    $("#financingplan #financingplanbtns .price > ul").removeAttr("style");

    //schedule tooltip
    if ($("#progressbar").length) {
      let _value = document.getElementById("progressbar").value;
      let _left;

      if (_value < 50) {
        _left = $("#progressbar").width() * (_value / 100) - 38;
        $("#stylesheet").html("");
      } else {
        _left = $("#progressbar").width() * (_value / 100) - 98;
        $("#stylesheet").html(
          "main#schedule section.cont #statusbar #tooltip div::before{left: 88px;} main#schedule section.cont #statusbar #tooltip div::after{left: 89px;}"
        );
      }
      $("#statusbar #tooltip").css({ left: _left + "px" });
    }
  } else {
    //schedule tooltip
    if ($("#progressbar").length) {
      let _value = document.getElementById("progressbar").value;
      let _left;
      if (_value <= 10) {
        _left = $("#progressbar").width() * (_value / 100) - 16;
        $("#stylesheet").html(
          "main#schedule section.cont #statusbar #tooltip div::before{left: 8px;} main#schedule section.cont #statusbar #tooltip div::after{left: 9px;}"
        );
      } else if (_value >= 75) {
        _left = $("#progressbar").width() * (_value / 100) - 115;
        $("#stylesheet").html(
          "main#schedule section.cont #statusbar #tooltip div::before{left: 105px;} main#schedule section.cont #statusbar #tooltip div::after{left: 106px;}"
        );
      } else {
        _left = $("#progressbar").width() * (_value / 100) - 38;
        $("#stylesheet").html("");
      }

      $("#statusbar #tooltip").css({ left: _left + "px" });
    }
  }

  // When crossing the slideshow area
  if ($(window).scrollTop() > 200 - $("header").height()) {
    /* header bg */
    if (!$("header").hasClass("bgactive")) $("header").addClass("bgactive");
    /* totop */
    if (!$("#totop").hasClass("active")) $("#totop").addClass("active");
    if (!$("#btnpopup").hasClass("active")) $("#btnpopup").addClass("active");
    if (!$("#modelfootbtns").hasClass("active")) {
      $("#modelfootbtns").css({ position: "fixed" });
      $("#modelfootbtns").addClass("active");
    }
    if (!$("#financingplanbtns").hasClass("active")) {
      $("#financingplanbtns").css({ position: "fixed" });
      if ($(window).width() <= maxWidth)
        $("#financingplanbtns .wrap").css({ width: "95%" });
      $("#financingplanbtns").addClass("active");
    }
  }
  if ($(window).scrollTop() + $(window).height() > $("footer").offset().top) {
    $("#btnpopup").css({
      position: "absolute",
      top: -($("#btnpopup").height() + $("#totop").height() + 20) + "px",
      bottom: "inherit"
    });
    $("#totop").css({
      position: "absolute",
      top: -($("#totop").height() + 10) + "px",
      bottom: "inherit"
    });
    $("#modelfootbtns").removeAttr("style");
    $("#financingplanbtns").removeAttr("style");
    $("#financingplanbtns .wrap").removeAttr("style");
  }

  //popup
  $(".contentpopup .popin").css({ "max-height": wH - 300 + "px" });
  $("#popup-flowchart.flowchartpopup .popin").css({ height: wH - 200 + "px" });

  // option total cost
  if ($("main#option").length || $("main#plandetail").length) {
    if (
      $(window).scrollTop() + $(window).height() >
      $("footer").offset().top - 20
    ) {
      if (!$("#footertotalcost").hasClass("active"))
        $("#footertotalcost").addClass("active");
      $("#footertotalcost").css({ position: "static" });
      $("#footertotalcost .wrap").css({ width: "100%" });
      $("section#option").removeAttr("style");
    } else {
      $("section#option").css({
        "padding-bottom": $("#footertotalcost").outerHeight() + "px"
      });
    }
  }

  // financingPlan button area
  if ($("main#financingplan").length) {
    if (
      $(window).scrollTop() + $(window).height() >
      $("footer").offset().top - 20
    ) {
      if (!$("#fpBtns").hasClass("active")) $("#fpBtns").addClass("active");
      $("#fpBtns").css({ position: "static" });
      $("#fpBtns .wrap").css({ width: "100%" });
      $("section#fp").removeAttr("style");
    } else {
      $("section#fp").css({
        "padding-bottom": $("#fpBtns").outerHeight() + "px"
      });
    }
  }
});
